// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__+-iQR","containerImg":"EmptyList_containerImg__SlxQU"};